var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLavalLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110px",
    height: "39px",
    viewBox: "0 0 110 39",
    style: {
      enableBackground: "new 0 0 110 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#0046BE;}\n\t.st2{fill:#AA3291;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.4,38.5l-1.1-3h-1.1l-1.1,3l-2.9,0l-1.9-1.8c-0.5,0.8-1.4,1.7-2.4,1.8c-1.9,0.4-3.1-1.3-4.3-2.5l0.9,2.5l-5.9,0 l-1.1-3h-1.1l-1.1,3l-11.9,0l-2.3-2.3V23.1H62l1.8,1.8v7.6l3.4,0l1.1,1.1l2.1-6c0.4-1.3,1.6-2.2,3-2.2c0.9,0,1.6,0.3,2.2,0.9 l2.8,2.8L77,25.5l4.4,0l2.6,2.6l0.9-2.6h4.4l1.2,1.2c0.6-0.7,1.5-1.2,2.5-1.2c0.9,0,1.6,0.3,2.2,0.9l3,3l0-6.3h3.8l1.8,1.8v7.6 l3.4,0l1.9,1.9v4.1H95.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.6,33.3 66.9,33.3 66.9,36 59,36 59,23.9 61.6,23.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.9,33.3h-1.9L71,36h-2.8l2.9-8.2c0.3-0.9,1.2-1.6,2.2-1.6c1,0,1.9,0.7,2.2,1.6l2.9,8.2h-2.8l-2.3-6.6 l-0.8,2.4h0.9L73.9,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,33.3h1.9l0.9,2.7h2.8l-2.9-8.2c-0.3-0.9-1.2-1.6-2.2-1.6c-1,0-1.9,0.7-2.2,1.6L87.9,36h2.8l2.3-6.6 l0.8,2.4H93L92.4,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,26.2h2.8l-2.9,8.2c-0.3,0.9-1.2,1.6-2.2,1.6c-1,0-1.9-0.7-2.2-1.6l-2.9-8.2h2.8l2.3,6.6L85.5,26.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "101.6,33.3 106.9,33.3 106.9,36 98.9,36 98.9,23.9 101.6,23.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1,0.4 1,15.8 23.8,38.5 53.4,38.5 53.4,23.2 45.2,15 30.8,15 16.3,0.4  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 1.2,
    className: "st0",
    width: 13.8,
    height: 13.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.1,15.8 15.6,15.8 30.2,30.3 44.4,30.3 51.9,37.7 24.1,37.7  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 15.7,
    className: "st0",
    width: 13.8,
    height: 13.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16.3,1.5 16.3,15.4 29.9,29 29.9,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "45.2,16 45.2,30 52.6,37.4 52.6,23.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavalLogoSmall);
export default __webpack_public_path__ + "static/media/laval-logo-small.89656597523b29c49248a675fa333ec0.svg";
export { ForwardRef as ReactComponent };